














import Typography from '@/components/atoms/Typography/Typography.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

import InfoIcon from '@/components/icons/Info.vue';

type FormLabelvariant = 'normal' | 'custom';

@Component({
  components: {
    Typography,
    InfoIcon
  }
})
export default class FormLabel extends Vue {
  @Prop({ default: 'normal' }) variant?: FormLabelvariant;
  @Prop({ default: '' }) tooltip?: string;
  @Prop({
    default: () => ({
      placement: 'right',
      arrow: true,
      arrowType: 'round',
      offset: '0, 10'
    })
  })
  tooltipConfig?: Record<string, any>;
}
